// extracted by mini-css-extract-plugin
export default {"registration":"registration___Val65","Steps":"Steps___NqoXy","taskItem":"taskItem___vtgoc"};